<div class="message-bar">
    <div class="message-bar__type-icon-wrapper">
        <mat-icon class="message-bar__type-icon">{{ data.icon }}</mat-icon>
    </div>
    <div class="message-bar__text">{{ data.message }}</div>
    <button class="message-bar__close-btn" mat-icon-button (click)="close()">
        <mat-icon class="message-bar__close-icon">close</mat-icon>
    </button>
</div>
